<template>
  <b-container>
    <b-card header-text-variant="dark">
        <div slot="header">
            <context-header title="Интервенције"></context-header>
        </div>
        <b-tabs content-class="mt-3">
          <b-tab title="Активација фактура" active>
            <activate-invoice></activate-invoice>
          </b-tab>
          <b-tab title="Измирење угашене организације">
            <closed-org-settlement></closed-org-settlement>
          </b-tab>
          <b-tab title="Пренос фактура">
            <move-invoices></move-invoices>
          </b-tab>          
      </b-tabs>
    </b-card>
  </b-container>
</template>

<script>
  import Vue from 'vue'
  import { EventBus } from '@/router/bus'
  import Loader from '@/components/misc/Loader'
  import ContextHeader from '@/components/misc/context-header/ContextHeader'
  import { Money } from 'v-money'
  import ActivateInvoice from './activate-invoice/ActivateInvoice'
  import ClosedOrgSettlement from './closed-org-settlement/ClosedOrgSettlement'
  import MoveInvoices from './move-invoices/MoveInvoices'

  export default {
    components: {
      Loader,
      ContextHeader,
      Money,
      ActivateInvoice,
      ClosedOrgSettlement,
      MoveInvoices
    },
    data () {
      return {
        settleByIdf: false,
        load: false,
        errorList: [],
        invoiceSettlement: {
          InvoiceNumber: '',
          DebtorCompanyNumber: '',
          CreditorCompanyNumber: '',
          CreditorTaxIdNumber: '',
          Bank: '',
          SettledAmount: 0
        },
        currency: {
          decimal: this.$store.getters.decimalFormat,
          thousands: this.$store.getters.decimalFormat === ',' ? '.' : ',',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        }
      }
    },
    computed: {
      showErrorContainer () {
        return this.errorList.length > 0
      }
    },
    methods: {
      submitSettlement: function (e) {
        this.logConsole('Submitting invoice settlement')
        this.load = true

        this.$http.post(Vue.$apiConfig.registerSettlementsPost, [this.invoiceSettlement])
          .then(response => {
            this.errorList = []
            this.logConsole(response)
            this.load = false
            // get body data
            if (!!response.data && Array.isArray(response.data.payload)) {
              response.data.payload.forEach(element => {
                if (element.settlementError) {
                  this.errorList.push(element)
                }
              })
            }
            if (this.errorList.length === 0) {
              let invoice = response.data
              EventBus.$emit('alert', {
                variant: 'success',
                message: 'Успешно измирен износ' + ' - ' + invoice.payload[0].settlement.settledAmount,
                errors: []
              })
            }
            this.$refs.registerSettlementForm.reset()
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error, 'invoices.invoiceLimitExceeded')
            this.load = false
          })
      }
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>
  @import '~@/assets/scss/variables.scss';

  .text-dark {
    font-weight: 600;
    font-size: 12pt;
    color: $font-color-dark !important;
  }
  
</style>



// WEBPACK FOOTER //
// Interventions.vue?f3fc3c6a